import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  ibes: null,
  currentIbe: null
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
